<template>
  <v-container>
    <v-row justify="center">
      <v-col :lg="6">
        <v-card>
          <v-card-title>
            <h3 class="headline">{{ $t('Profile') }}</h3>
          </v-card-title>
          <form @submit.prevent="update">
            <v-card-text>
              <div class="text-right">
                <v-btn
                  data-cy="button-update-profile"
                  class="mr-2"
                  fab
                  :dark="!formEnable"
                  small
                  @click="formEnable = !formEnable"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </div>
              <validation-observer ref="form">
                <validation-provider v-slot="{errors}" name="name" rules="required|max:255">
                  <v-col cols="12">
                    <v-text-field
                      name="name"
                      id="name"
                      v-model="name"
                      :label="$t('Name')"
                      :placeholder="placeholderName"
                      :disabled="formEnable"
                      :error-messages="errors"
                      required
                    ></v-text-field>
                  </v-col>
                </validation-provider>
                <validation-provider v-slot="{errors}" name="email" rules="required|email|max:255">
                  <v-col cols="12">
                    <v-text-field
                      name="e-mail"
                      :label="$t('E-mail')"
                      :placeholder="placeholderEmail"
                      id="e-mail"
                      v-model="email"
                      disabled
                      :error-messages="errors"
                      required
                    ></v-text-field>
                  </v-col>
                </validation-provider>
              </validation-observer>
              <v-col cols="12">
                <v-btn text color="primary" @click="modifPassword">{{ $t('Change password')}}</v-btn>
              </v-col>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="cancel">{{ $t('Cancel') }}</v-btn>
              <v-btn
                data-cy="button-save-profile"
                :loading="loading"
                color="success"
                type="submit"
              >{{ $t('Save') }}</v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import snackbar from "@/mixins/snackbar";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  name: "User",
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  mixins: [snackbar],
  data() {
    return {
      name: this.$store.state.auth.user.name,
      email: this.$store.state.auth.user.email,
      error: false,
      loading: false,
      formEnable: true,
      placeholderName: this.$store.state.auth.user.name,
      placeholderEmail: this.$store.state.auth.user.email,
    };
  },
  methods: {
    cancel() {
      this.$router.push({ name: "Home" });
    },
    modifPassword() {
      this.$router.push({ name: "PasswordUpdate" });
    },

    update() {
      this.$refs.form.validate().then((success) => {
        if (!success) {
          return;
        }
        this.loading = true;
        const data = {
          name: this.name,
        };
        this.$store
          .dispatch("auth/updateUser", data)
          .then(() => {
            this.loading = false;
            this.snackbar("success", this.$t("Your name has been updated !"));
            this.formEnable = true;
          })
          .catch((error) => {
            if (error.response.status === 422) {
              this.$refs.form.setErrors(error.response.data.errors);
            } else {
              this.snackbar(
                "error",
                this.$t(
                  "An error occured during update the user, please try again"
                )
              );
            }
            this.loading = false;
          });
      });
    },
  },
};
</script>